import createHash from "create-hash";
let base = 0;
export const objectToHash = (entry, objectToAppend) => createHash("md5")
    .update(JSON.stringify(entry || {}) + JSON.stringify(objectToAppend || {}) + base.toString())
    .digest("hex");
export const changeHash = () => {
    base += 1;
};
export const isEmpty = (obj = {}) => Object.keys(obj).length === 0 ||
    obj === null || obj === undefined ||
    Object.keys(obj).every((key) => obj[key] === null || obj[key] === undefined);
